const toastr = {
  positionClass: 'toast-top-right',
};

export default toastr;
